import { RpcOptions, UnaryCall } from "@protobuf-ts/runtime-rpc"
import { TwirpFetchTransport } from "@protobuf-ts/twirp-transport"
import {
  InfiniteData,
  QueryKey,
  UseInfiniteQueryResult,
  UseQueryResult,
  hashKey,
  keepPreviousData,
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { Report } from "gen/analytics/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import {
  BulkExportAccountsReq,
  BulkExportAccountsRes,
  BulkExportClassesReq,
  BulkExportClassesRes,
  BulkExportCustomPriceRulesReq,
  BulkExportCustomPriceRulesRes,
  BulkExportCustomerContactsReq,
  BulkExportCustomerContactsRes,
  BulkExportCustomersReq,
  BulkExportCustomersRes,
  BulkExportDepartmentsReq,
  BulkExportDepartmentsRes,
  BulkExportFinelineReq,
  BulkExportFinelineRes,
  BulkExportInventoryCountProductsReq,
  BulkExportInventoryCountProductsRes,
  BulkExportJobsReq,
  BulkExportJobsRes,
  BulkExportMappingsReq,
  BulkExportMappingsRes,
  BulkExportProductLabelsReq,
  BulkExportProductLabelsRes,
  BulkExportProductsReq,
  BulkExportProductsRes,
  BulkExportSpiffsReq,
  BulkExportSpiffsRes,
  BulkExportStaffReq,
  BulkExportStaffRes,
  BulkExportTagsReq,
  BulkExportTagsRes,
  BulkExportUnitsOfMeasureReq,
  BulkExportUnitsOfMeasureRes,
  BulkExportVendorsReq,
  BulkExportVendorsRes,
  GetBalanceSheetReq,
  GetBalanceSheetRes,
  GetGeneralLedgerCSVReq,
  GetGeneralLedgerPDFReq,
  GetGeneralLedgerReq,
  GetIncomeStatementReq,
  GetIncomeStatementRes,
  GetJournalEntriesIIFReq,
  GetJournalEntriesPDFReq,
  GetJournalEntriesReq,
  GetJournalEntriesRes,
  GetPayoutsByPayoutDateCSVReq,
  GetPayoutsByPayoutDatePDFReq,
  GetPayoutsByPayoutDateReq,
  GetPayoutsByTransactionDateCSVReq,
  GetPayoutsByTransactionDatePDFReq,
  GetPayoutsByTransactionDateReq,
  GetProfitAndLossPDFReq,
  GetProfitAndLossReq,
  GetProfitAndLossRes,
  GetPurchaseJournalCSVReq,
  GetPurchaseJournalPDFReq,
  GetPurchaseJournalReq,
  GetReportBuilderReq,
  GetReportBuilderRes,
  ListIntegrationVendorsWithCatalogsRes,
  OmniSearchReq,
  OmniSearchRes,
  OmniSearchRes_Result,
  PollForNewChatMessagesReq,
  PollForUnreadChatThreadsReq,
  PrintReceivablesAgingReq,
  PrintReceivablesAgingRes,
  PrintReceivablesHistoryReq,
  PrintReceivablesHistoryRes,
  SearchAccountsReq,
  SearchAccountsRes,
  SearchAccountsRes_Result,
  SearchBillPaymentsRes_Result as SearchBillPaymentResult,
  SearchBillPaymentsReq,
  SearchBillPaymentsRes,
  SearchCashTransactionsRes_Result as SearchCashTransactionResult,
  SearchCashTransactionsReq,
  SearchCashTransactionsRes,
  SearchCatalogProductsReq,
  SearchCatalogProductsRes,
  SearchCatalogProductsRes_Result as SearchCatalogProductsResult,
  SearchCatalogSKUsReq,
  SearchCatalogSKUsRes,
  SearchCatalogSKUsRes_Result as SearchCatalogSKUsResult,
  SearchChatMessagesReq,
  SearchChatMessagesRes,
  SearchChatMessagesRes_Result,
  SearchChatThreadsReq,
  SearchChatThreadsRes,
  SearchChatThreadsRes_Result,
  SearchConversationsReq,
  SearchConversationsRes,
  SearchConversationsRes_Result,
  SearchCreditsReq,
  SearchCreditsRes,
  SearchCreditsRes_Result as SearchCreditsResult,
  SearchCustomPriceRulesReq,
  SearchCustomPriceRulesRes,
  SearchCustomPriceRulesRes_Result as SearchCustomPriceRulesResult,
  SearchCustomerContactsReq,
  SearchCustomerContactsRes,
  SearchCustomerContactsRes_Result,
  SearchCustomerStatementsReq,
  SearchCustomerStatementsRes,
  SearchCustomerStatementsRes_Result,
  SearchCustomersV2Req,
  SearchCustomersV2Res,
  SearchCustomersV2Res_Result as SearchCustomersV2Result,
  SearchDeliveriesReq,
  SearchDeliveriesRes,
  SearchDeliveriesRes_Result as SearchDeliveriesResult,
  SearchDeliveryStopsReq,
  SearchDeliveryStopsRes,
  SearchDeliveryStopsRes_Result as SearchDeliveryStopsResult,
  SearchExcludedInventoryCountProductsReq,
  SearchExcludedInventoryCountProductsRes,
  SearchExcludedInventoryCountProductsRes_Result as SearchExcludedInventoryCountProductsResult,
  SearchExternalTransactionsReq,
  SearchExternalTransactionsRes,
  SearchExternalTransactionsRes_Result as SearchExternalTransactionsResult,
  SearchFinanceChargesReq,
  SearchFinanceChargesRes,
  SearchFinanceChargesRes_Result as SearchFinanceChargesResult,
  SearchFinancialTransactionsReq,
  SearchFinancialTransactionsRes,
  SearchFinancialTransactionsRes_Result as SearchFinancialTransactionsResult,
  SearchGiftCardsReq,
  SearchGiftCardsRes,
  SearchGiftCardsRes_Result as SearchGiftCardsResult,
  SearchInventoryChangesReq,
  SearchInventoryChangesRes,
  SearchInventoryChangesRes_Result as SearchInventoryChangesResult,
  SearchInventoryCountProductsReq,
  SearchInventoryCountProductsRes,
  SearchInventoryCountProductsRes_Result as SearchInventoryCountProductsResult,
  SearchJobsReq,
  SearchJobsRes,
  SearchJobsRes_Result as SearchJobsResult,
  SearchJournalEntriesReq,
  SearchJournalEntriesRes,
  SearchJournalEntriesRes_Result,
  SearchListPromotionalSaleCodesRes,
  SearchLocationsReq,
  SearchLocationsRes,
  SearchLocationsRes_Result as SearchLocationsResult,
  SearchManualJournalEntriesReq,
  SearchManualJournalEntriesRes,
  SearchManualJournalEntriesRes_Result,
  SearchMappingsReq,
  SearchMappingsRes,
  SearchMappingsRes_Result,
  SearchNotifDeliveriesReq,
  SearchNotifDeliveriesRes,
  SearchNotifDeliveriesRes_Result,
  PreviewGeneratedOrderProductsReq,
  PreviewGeneratedOrderProductsReq_Mode,
  SearchOrderShipmentsForReconciliationReq,
  SearchOrderShipmentsForReconciliationRes,
  SearchOrderShipmentsForReconciliationRes_Result as SearchOrderShipmentsForReconciliationResult,
  SearchOrderShipmentsReq,
  SearchOrderShipmentsRes,
  SearchOrderShipmentsRes_Result as SearchOrderShipmentsResult,
  SearchOrdersReq,
  SearchOrdersRes,
  SearchOrdersRes_Result as SearchOrdersResult,
  SearchPriceChangesReq,
  SearchPriceChangesRes,
  SearchPriceChangesRes_Result as SearchPriceChangesResult,
  SearchPriceTierRulesReq,
  SearchPriceTierRulesRes,
  SearchPriceTierRulesRes_Result as SearchPriceTierRulesResult,
  SearchProductsV2Req,
  SearchProductsV2Res,
  SearchProductsV2Res_Result as SearchProductsV2Result,
  SearchReallocationReceivablesReq,
  SearchReallocationReceivablesRes,
  SearchReallocationReceivablesRes_Result,
  SearchReceivablesAgingReq,
  SearchReceivablesAgingRes,
  SearchReceivablesAgingRes_Result as SearchReceivablesAgingResult,
  SearchReceivablesHistoryReq,
  SearchReceivablesHistoryRes,
  SearchReceivablesHistoryRes_Result as SearchReceivablesHistoryResult,
  SearchRefundedBillPaymentsRes_Result as SearchRefundedBillPaymentResult,
  SearchRefundedBillPaymentsReq,
  SearchRefundedBillPaymentsRes,
  SearchReturnableSaleProductsReq,
  SearchReturnableSaleProductsRes,
  SearchReturnableSaleProductsRes_Result as SearchReturnableSaleProductsResult,
  SearchSalesV2Req,
  SearchSalesV2Res,
  SearchSalesV2Res_Result as SearchSalesV2Result,
  SearchSavedReportsReq,
  SearchSavedReportsRes,
  SearchSavedReportsRes_Result,
  SearchSpiffsReq,
  SearchSpiffsRes,
  SearchSpiffsRes_Result as SearchSpiffsResult,
  SearchStaffsReq,
  SearchStaffsRes,
  SearchStaffsRes_Result as SearchStaffsResult,
  SearchStagedProductsToOrderReq,
  SearchStagedProductsToOrderRes,
  SearchStagedProductsToOrderRes_Result,
  SearchStatementRunsReq,
  SearchStatementRunsRes,
  SearchStatementRunsRes_Result,
  SearchStatementsReq,
  SearchStatementsRes,
  SearchStatementsRes_Result,
  SearchTagsReq,
  SearchTagsRes,
  SearchTagsRes_Result,
  SearchTenderMethodsReq,
  SearchTenderMethodsRes,
  SearchTenderMethodsRes_Result as SearchTenderMethodsResult,
  SearchTintColorsReq,
  SearchTintColorsRes,
  SearchTintColorsRes_Result as SearchTintColorsResult,
  SearchTransfersReq,
  SearchTransfersRes,
  SearchTransfersRes_Result as SearchTransfersResult,
  SearchVendorsReq,
  SearchVendorsRes,
  SearchVendorsRes_Result as SearchVendorsResult,
  SearchRoutinesReq,
  SearchRoutinesRes,
  SearchRoutinesRes_Result,
} from "gen/search/service/service_pb"
import {
  BulkServiceClient,
  SearchServiceClient,
  SearchalyticsServiceClient,
} from "gen/search/service/service_pb.client"
import { OrderProductFilter } from "gen/txn/models_pb"
import { useRouter } from "next/router"
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useDeferredValue,
  useMemo,
  useState,
} from "react"
import { UUID } from "shared-ts/classes/uuid"

import { useAppSelector } from "app/hooks"
import { selectCompanySearchUrl } from "features/auth/authSlice"
import {
  SerializableReq,
  parseReport,
  restoreSerializableReq,
} from "features/pos/analytics/Reports/configuration/helpers"
import {
  useLazyReportDataRes,
  useLazyReportFileRes,
} from "features/pos/analytics/Reports/types"
import { stringify } from "lib/stringify"

import { ApiError } from "./apiSlice"

interface PageParam {
  cursor: string
  offset: number
}

export type UseSearchQueryHookArg<Request extends { query: string }> =
  Partial<Request>

export interface SearchOptions {
  skip?: boolean
  /** Set to true if the usage of usePaginatedSearch exists in popup / modal that shouldn't read ?q= from the url */
  ignoreSearchQuery?: boolean
}

type UseSearchQueryHookBaseResult<T> = {
  query: string
  setQuery: Dispatch<SetStateAction<string>>
  results: T[]
}

type UsePaginatedSearchQueryHookBaseResult<T> =
  UseSearchQueryHookBaseResult<T> & {
    loadNext: () => void
  }

type UsePaginatedSearchQueryHookResult<Response, Result> =
  UseInfiniteQueryResult<InfiniteData<Response, PageParam>, Error> &
    UsePaginatedSearchQueryHookBaseResult<Result>

type UseUnpaginatedSearchQueryHookResult<Response, Result> = UseQueryResult<
  Response,
  Error
> &
  UseSearchQueryHookBaseResult<Result>

type UseLazyUnpaginatedSearchQueryHookResult<Response, Result> = UseQueryResult<
  Response,
  Error
> &
  UseSearchQueryHookBaseResult<Result> & {
    triggerRefetch: () => void
  }

type SearchClient<T> = {
  client: T
  isReady: boolean
}

function useServiceClient<
  T extends
    | BulkServiceClient
    | SearchServiceClient
    | SearchalyticsServiceClient,
>(
  ClientConstructor: new (transport: TwirpFetchTransport) => T
): SearchClient<T> {
  const companySearchUrl = useAppSelector(selectCompanySearchUrl)
  const client = new ClientConstructor(
    new TwirpFetchTransport({
      baseUrl:
        process.env.NEXT_PUBLIC_VERCEL_ENV === "development"
          ? `/search/twirp`
          : `${companySearchUrl}/twirp`,
      fetchInit: { credentials: "include" },
      sendJson: true,
      jsonOptions: { ignoreUnknownFields: true },
    })
  )

  return {
    client,
    isReady: !!companySearchUrl,
  }
}

function useBulkClient(): SearchClient<BulkServiceClient> {
  return useServiceClient(BulkServiceClient)
}

export function useSearchClient(): SearchClient<SearchServiceClient> {
  return useServiceClient(SearchServiceClient)
}

export function useSearchalyticsClient(): SearchClient<SearchalyticsServiceClient> {
  return useServiceClient(SearchalyticsServiceClient)
}

function useBulkMutation<Req extends object, Res extends object>(
  key: keyof BulkServiceClient
) {
  const { client } = useBulkClient()

  const fn = (
    client[key] as (input: Req, options?: RpcOptions) => UnaryCall<Req, Res>
  ).bind(client)

  return useMutation<Res, ApiError, Req>({
    mutationFn: async (req: Req): Promise<Res> => {
      const res = await fn(req)
      return res.response
    },
  })
}

export function useBulkExportCustomers() {
  return useBulkMutation<BulkExportCustomersReq, BulkExportCustomersRes>(
    "bulkExportCustomers"
  )
}

export function useBulkExportJobs() {
  return useBulkMutation<BulkExportJobsReq, BulkExportJobsRes>("bulkExportJobs")
}

export function useBulkExportCustomerContacts() {
  return useBulkMutation<
    BulkExportCustomerContactsReq,
    BulkExportCustomerContactsRes
  >("bulkExportCustomerContacts")
}

export function useBulkExportCustomPriceRules() {
  return useBulkMutation<
    BulkExportCustomPriceRulesReq,
    BulkExportCustomPriceRulesRes
  >("bulkExportCustomPriceRules")
}

export function useBulkExportInventoryCountProducts() {
  return useBulkMutation<
    BulkExportInventoryCountProductsReq,
    BulkExportInventoryCountProductsRes
  >("bulkExportInventoryCountProducts")
}

export function useBulkExportProducts() {
  return useBulkMutation<BulkExportProductsReq, BulkExportProductsRes>(
    "bulkExportProducts"
  )
}

export function useBulkExportProductLabels() {
  return useBulkMutation<
    BulkExportProductLabelsReq,
    BulkExportProductLabelsRes
  >("bulkExportProductLabels")
}

export function useBulkExportVendors() {
  return useBulkMutation<BulkExportVendorsReq, BulkExportVendorsRes>(
    "bulkExportVendors"
  )
}

export function useBulkExportUnitsOfMeasure() {
  return useBulkMutation<
    BulkExportUnitsOfMeasureReq,
    BulkExportUnitsOfMeasureRes
  >("bulkExportUnitsOfMeasure")
}

export function useBulkExportSpiffs() {
  return useBulkMutation<BulkExportSpiffsReq, BulkExportSpiffsRes>(
    "bulkExportSpiffs"
  )
}

export function useBulkExportStaff() {
  return useBulkMutation<BulkExportStaffReq, BulkExportStaffRes>(
    "bulkExportStaff"
  )
}

export function useBulkExportDepartments() {
  return useBulkMutation<BulkExportDepartmentsReq, BulkExportDepartmentsRes>(
    "bulkExportDepartments"
  )
}

export function useBulkExportClasses() {
  return useBulkMutation<BulkExportClassesReq, BulkExportClassesRes>(
    "bulkExportClasses"
  )
}

export function useBulkExportFinelines() {
  return useBulkMutation<BulkExportFinelineReq, BulkExportFinelineRes>(
    "bulkExportFinelines"
  )
}

export function useBulkExportTags() {
  return useBulkMutation<BulkExportTagsReq, BulkExportTagsRes>("bulkExportTags")
}

const SearchQueryKeys = {
  FinancialTransactions: "financial-transactions",
  ExternalTransactions: "external-transactions",
  CashTransactions: "cash-transactions",
  Mappings: "mappings",
  Accounts: "accounts",
} as const

function useSearchQueryParam() {
  const router = useRouter()
  return useMemo<string | undefined>(() => {
    if (Array.isArray(router.query.q)) {
      return ""
    }
    return router.query.q
  }, [router.query.q])
}

function usePaginatedSearch<
  SearchReq extends { query: string },
  SearchResult,
  SearchRes extends {
    results: SearchResult[]
    cursor: string
  },
>(
  key: keyof SearchServiceClient,
  queryKey: string,
  SearchReqInstanceType: { create: () => SearchReq },
  arg?: UseSearchQueryHookArg<Omit<SearchReq, "offset" | "cursor">>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchRes, SearchResult> {
  const { client, isReady } = useSearchClient()

  const fn = (
    client[key] as (
      input: SearchReq,
      options?: RpcOptions
    ) => UnaryCall<SearchReq, SearchRes>
  ).bind(client)

  const defaultArgs = useMemo(
    () => SearchReqInstanceType.create(),
    [SearchReqInstanceType]
  )

  const { skip, ignoreSearchQuery } = options ?? {}

  const searchQueryParam = useSearchQueryParam()
  const initialQuery = arg?.query ?? ""
  const [query, setQuery] = useState(
    ignoreSearchQuery ? initialQuery : searchQueryParam ?? initialQuery
  )
  const deferredQuery = useDeferredValue(query)

  const res = useInfiniteQuery<
    SearchRes,
    Error,
    InfiniteData<SearchRes, PageParam>,
    QueryKey,
    PageParam
  >({
    queryKey: ["search", queryKey, defaultArgs, arg, deferredQuery],
    queryKeyHashFn: (queryKey) => {
      const serializable = queryKey.map((key) => stringify(key))
      return hashKey(serializable)
    },
    initialPageParam: {
      cursor: "",
      offset: 0,
    },
    queryFn: async ({ pageParam }) => {
      const req: SearchReq = {
        ...defaultArgs,
        ...arg,
        query: deferredQuery,
        cursor: pageParam.cursor,
        offset: pageParam.offset,
      }
      const { response } = await fn(req)
      return response
    },
    getNextPageParam: (lastPage, allPages) =>
      lastPage.cursor
        ? {
            cursor: lastPage.cursor,
            offset: allPages.flatMap((x) => x.results).length,
          }
        : undefined,
    placeholderData: keepPreviousData,
    enabled: !skip && isReady,
  })

  const { hasNextPage, fetchNextPage, isFetching } = res
  const loadNext = useCallback(() => {
    if (hasNextPage && !isFetching) {
      fetchNextPage()
    }
  }, [hasNextPage, fetchNextPage, isFetching])

  const results = res.data?.pages.flatMap((page) => page.results) ?? []

  return {
    ...res,
    query,
    setQuery,
    results,
    loadNext,
  }
}

export function useUnpaginatedSearch<
  SearchReq extends { query: string; limit?: number },
  SearchResult,
  SearchRes extends {
    results: SearchResult[]
  },
>(
  key: keyof SearchServiceClient,
  queryKey: string,
  SearchReqInstanceType: { create: () => SearchReq },
  arg?: UseSearchQueryHookArg<Omit<SearchReq, "offset" | "cursor">>,
  options?: SearchOptions,
  preserveResults?: boolean,
  argQuery?: boolean
): UseUnpaginatedSearchQueryHookResult<SearchRes, SearchResult> {
  const { client, isReady } = useSearchClient()

  const fn = (
    client[key] as (
      input: SearchReq,
      options?: RpcOptions
    ) => UnaryCall<SearchReq, SearchRes>
  ).bind(client)

  const defaultArgs = useMemo(
    () => SearchReqInstanceType.create(),
    [SearchReqInstanceType]
  )
  const { skip } = options ?? {}
  const [query, setQuery] = useState<string>("")
  const deferredQuery = useDeferredValue(query)

  const res = useQuery<SearchRes, Error>({
    queryKey: ["search", queryKey, defaultArgs, arg, deferredQuery, argQuery],
    queryKeyHashFn: (queryKey) => {
      const serializable = queryKey.map((key) => stringify(key))
      return hashKey(serializable)
    },
    queryFn: async () => {
      const req: SearchReq = {
        ...defaultArgs,
        ...arg,
      }
      if (!argQuery) {
        req.query = deferredQuery
      }
      const { response } = await fn(req)
      return response
    },
    placeholderData: preserveResults ? undefined : keepPreviousData,
    enabled: !skip && isReady,
  })

  const results = res.data?.results ?? []

  return {
    ...res,
    query,
    setQuery,
    results,
  }
}

export function useLazySearch<
  SearchReq extends { query: string },
  SearchResult,
  SearchRes extends {
    results: SearchResult[]
  },
>(
  key: keyof SearchServiceClient,
  queryKey: string,
  SearchReqInstanceType: { create: () => SearchReq },
  arg?: UseSearchQueryHookArg<Omit<SearchReq, "offset" | "cursor">>,
  preserveResults?: boolean,
  argQuery?: boolean
): UseLazyUnpaginatedSearchQueryHookResult<SearchRes, SearchResult> {
  const res = useUnpaginatedSearch<SearchReq, SearchResult, SearchRes>(
    key,
    queryKey,
    SearchReqInstanceType,
    arg,
    { skip: true },
    preserveResults,
    argQuery
  )

  return {
    ...res,
    triggerRefetch: () => res.refetch(),
    query: res.query,
    setQuery: res.setQuery,
    results: res.results,
  }
}

export function useGetReportBuilderCSV() {
  const { client } = useSearchalyticsClient()
  return useMutation<
    GetReportBuilderRes,
    ApiError,
    Pick<GetReportBuilderReq, "params">
  >({
    mutationFn: async (req) => {
      const { response } = await client.getReportBuilder({
        ...req,
        toCsv: true,
        toPdf: false,
        savedReportName: "",
      })
      return response
    },
  })
}

export function useOmniSearch(
  arg?: UseSearchQueryHookArg<OmniSearchReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<OmniSearchRes, OmniSearchRes_Result> {
  return usePaginatedSearch(
    "omniSearch",
    "omni-search",
    OmniSearchReq,
    arg,
    options
  )
}

export function useSearchBills(
  arg?: UseSearchQueryHookArg<SearchBillPaymentsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchBillPaymentsRes,
  SearchBillPaymentResult
> {
  return usePaginatedSearch(
    "searchBillPayments",
    "bill-payments",
    SearchBillPaymentsReq,
    arg,
    options
  )
}

export function useSearchRefundedBills(
  arg?: UseSearchQueryHookArg<SearchRefundedBillPaymentsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchRefundedBillPaymentsRes,
  SearchRefundedBillPaymentResult
> {
  return usePaginatedSearch(
    "searchRefundedBillPayments",
    "refunded-bill-payments",
    SearchRefundedBillPaymentsReq,
    arg,
    options
  )
}

export function useSearchReturnableSaleProducts(
  arg?: UseSearchQueryHookArg<SearchReturnableSaleProductsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchReturnableSaleProductsRes,
  SearchReturnableSaleProductsResult
> {
  return usePaginatedSearch(
    "searchReturnableSaleProducts",
    "returnable-sale-products",
    SearchReturnableSaleProductsReq,
    arg,
    options
  )
}

export function useLazySearchReturnableSaleProducts(
  arg?: UseSearchQueryHookArg<SearchReturnableSaleProductsReq>
): UseLazyUnpaginatedSearchQueryHookResult<
  SearchReturnableSaleProductsRes,
  SearchReturnableSaleProductsResult
> {
  return useLazySearch<
    SearchReturnableSaleProductsReq,
    SearchReturnableSaleProductsResult,
    SearchReturnableSaleProductsRes
  >(
    "searchReturnableSaleProducts",
    "returnable-sale-products",
    SearchReturnableSaleProductsReq,
    arg,
    true
  )
}

export function useSearchStaffs(
  arg?: UseSearchQueryHookArg<SearchStaffsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchStaffsRes, SearchStaffsResult> {
  return usePaginatedSearch(
    "searchStaffs",
    "staffs",
    SearchStaffsReq,
    arg,
    options
  )
}

export function useSearchCustomersV2(
  arg?: UseSearchQueryHookArg<SearchCustomersV2Req>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchCustomersV2Res,
  SearchCustomersV2Result
> {
  return usePaginatedSearch(
    "searchCustomersV2",
    "customers",
    SearchCustomersV2Req,
    arg,
    options
  )
}

export function useSearchCustomerContacts(
  arg?: UseSearchQueryHookArg<SearchCustomerContactsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchCustomerContactsRes,
  SearchCustomerContactsRes_Result
> {
  return usePaginatedSearch(
    "searchCustomerContacts",
    "customer-contacts",
    SearchCustomerContactsReq,
    arg,
    options
  )
}

export function useSearchChatThreads(
  arg?: UseSearchQueryHookArg<SearchChatThreadsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchChatThreadsRes,
  SearchChatThreadsRes_Result
> {
  return usePaginatedSearch(
    "searchChatThreads",
    "chat-threads",
    SearchChatThreadsReq,
    arg,
    options
  )
}

function areThreadResultsEqual(
  a?: SearchChatThreadsRes_Result,
  b?: SearchChatThreadsRes_Result
): boolean {
  if (a === undefined && b === undefined) {
    return true
  }
  if (a === undefined || b === undefined) {
    return false
  }
  return (
    UUID.eqFromPB(a.thread?.id, b.thread?.id) &&
    UUID.eqFromPB(a.latestMessage?.id, b.latestMessage?.id)
  )
}

export function usePollForNewChatThreadActivity({
  req,
  currentFirstResult,
  refetchInterval,
  skip,
}: {
  req: SearchChatThreadsReq
  currentFirstResult?: SearchChatThreadsRes_Result
  refetchInterval: number
  skip?: boolean
}) {
  const { client, isReady } = useSearchClient()
  return useQuery({
    queryKey: [
      "search",
      "poll-new-chat-thread-activity",
      currentFirstResult,
      req,
    ],
    queryKeyHashFn: (queryKey) => {
      const serializable = queryKey.map((key) => stringify(key))
      return hashKey(serializable)
    },
    queryFn: async () => {
      const { response } = await client.searchChatThreads(req)
      return {
        hasNewActivity: !areThreadResultsEqual(
          currentFirstResult,
          response.results[0]
        ),
      }
    },
    refetchInterval,
    enabled: !skip && isReady,
  })
}

export function usePollForUnreadChatThreads({
  req,
  refetchInterval,
  skip,
}: {
  req: PollForUnreadChatThreadsReq
  refetchInterval: number
  skip?: boolean
}) {
  const { client, isReady } = useSearchClient()
  return useQuery({
    queryKey: ["search", "poll-unread-chat-threads", req],
    queryFn: async () => {
      const { response } = await client.pollForUnreadChatThreads(req)
      return response
    },
    refetchInterval,
    enabled: !skip && isReady,
  })
}

export function useSearchChatMessages(
  arg?: UseSearchQueryHookArg<SearchChatMessagesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchChatMessagesRes,
  SearchChatMessagesRes_Result
> {
  return usePaginatedSearch(
    "searchChatMessages",
    "chat-messages",
    SearchChatMessagesReq,
    arg,
    options
  )
}

export function usePollForNewChatMessages({
  req,
  refetchInterval,
  skip,
}: {
  req: PollForNewChatMessagesReq
  refetchInterval: number
  skip?: boolean
}) {
  const { client, isReady } = useSearchClient()
  return useQuery({
    queryKey: ["search", "poll-new-chat-messages", req],
    queryFn: async () => {
      const { response } = await client.pollForNewChatMessages(req)
      return response
    },
    refetchInterval,
    enabled: !skip && isReady,
  })
}

export function useSearchInventoryCountProducts(
  arg?: UseSearchQueryHookArg<
    Omit<SearchInventoryCountProductsReq, "offset" | "cursor">
  >,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchInventoryCountProductsRes,
  SearchInventoryCountProductsResult
> {
  return usePaginatedSearch(
    "searchInventoryCountProducts",
    "inventory-count-products",
    SearchInventoryCountProductsReq,
    arg,
    options
  )
}

export function useUnpaginatedSearchInventoryCountProducts(
  arg: UseSearchQueryHookArg<
    Omit<SearchInventoryCountProductsReq, "offset" | "cursor">
  >,
  options?: SearchOptions
): UseUnpaginatedSearchQueryHookResult<
  SearchInventoryCountProductsRes,
  SearchInventoryCountProductsResult
> {
  return useUnpaginatedSearch(
    "searchInventoryCountProducts",
    "inventory-count-products",
    SearchInventoryCountProductsReq,
    arg,
    options
  )
}

export function useInvalidateSearchInventoryCountProducts(): () => Promise<void> {
  const queryClient = useQueryClient()
  return useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: ["search", "inventory-count-products"],
      }),
    [queryClient]
  )
}

export function useSearchExcludedInventoryCountProducts(
  arg?: UseSearchQueryHookArg<SearchExcludedInventoryCountProductsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchExcludedInventoryCountProductsRes,
  SearchExcludedInventoryCountProductsResult
> {
  return usePaginatedSearch(
    "searchExcludedInventoryCountProducts",
    "excluded-inventory-count-products",
    SearchExcludedInventoryCountProductsReq,
    arg,
    options
  )
}

export function useSearchLocations(
  arg?: UseSearchQueryHookArg<SearchLocationsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchLocationsRes,
  SearchLocationsResult
> {
  return usePaginatedSearch(
    "searchLocations",
    "locations",
    SearchLocationsReq,
    arg,
    options
  )
}

export function useSearchTenderMethods(
  arg?: UseSearchQueryHookArg<SearchTenderMethodsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchTenderMethodsRes,
  SearchTenderMethodsResult
> {
  return usePaginatedSearch(
    "searchTenderMethods",
    "tender-methods",
    SearchTenderMethodsReq,
    arg,
    options
  )
}

export function useInvalidateSearchTenderMethods() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["search", "tender-methods"],
    })
  }
}

export function useSearchOrders(
  arg?: UseSearchQueryHookArg<SearchOrdersReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchOrdersRes, SearchOrdersResult> {
  return usePaginatedSearch(
    "searchOrders",
    "orders",
    SearchOrdersReq,
    arg,
    options
  )
}

// usePreviewGeneratedOrderProducts previews the products an order would be generated for.
// It answers from the search cache, so the result reflects a slightly older
// snapshot than the order service's own view of the same request.
export function usePreviewGeneratedOrderProducts(
  {
    mode,
    vendorId,
    locationId,
    weeks,
    matchVendorOnAllCosts,
    filters,
  }: {
    mode: PreviewGeneratedOrderProductsReq_Mode
    vendorId?: PBUUID
    locationId?: PBUUID
    weeks: number
    matchVendorOnAllCosts: boolean
    filters: OrderProductFilter
  },
  { skip }: { skip?: boolean } = {}
) {
  const { client, isReady } = useSearchClient()
  const req = useMemo(
    () =>
      PreviewGeneratedOrderProductsReq.create({
        mode,
        vendorId,
        locationId,
        weeks,
        matchVendorOnAllCosts,
        filters,
      }),
    [mode, vendorId, locationId, weeks, matchVendorOnAllCosts, filters]
  )
  return useQuery({
    queryKey: ["search", "order-products", req],
    queryKeyHashFn: (queryKey) => hashKey(queryKey.map((k) => stringify(k))),
    queryFn: async () => {
      const { response } = await client.previewGeneratedOrderProducts(req)
      return response
    },
    placeholderData: keepPreviousData,
    enabled: !skip && isReady,
  })
}

export function useSearchOrderShipments(
  arg?: UseSearchQueryHookArg<SearchOrderShipmentsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchOrderShipmentsRes,
  SearchOrderShipmentsResult
> {
  return usePaginatedSearch(
    "searchOrderShipments",
    "order-shipments",
    SearchOrderShipmentsReq,
    arg,
    options
  )
}

export function useSearchProductsV2(
  arg?: UseSearchQueryHookArg<SearchProductsV2Req>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchProductsV2Res,
  SearchProductsV2Result
> {
  return usePaginatedSearch(
    "searchProductsV2",
    "products",
    SearchProductsV2Req,
    arg,
    options
  )
}

export function useSearchCustomPriceRules(
  arg?: UseSearchQueryHookArg<SearchCustomPriceRulesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchCustomPriceRulesRes,
  SearchCustomPriceRulesResult
> {
  return usePaginatedSearch(
    "searchCustomPriceRules",
    "custom-price-rules",
    SearchCustomPriceRulesReq,
    arg,
    options
  )
}

export function useSearchPriceTierRules(
  arg?: UseSearchQueryHookArg<SearchPriceTierRulesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchPriceTierRulesRes,
  SearchPriceTierRulesResult
> {
  return usePaginatedSearch(
    "searchPriceTierRules",
    "price-tier-rules",
    SearchPriceTierRulesReq,
    arg,
    options
  )
}

export function useInvalidateSearchPriceTierRules() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["search", "price-tier-rules"],
    })
  }
}

export function useSearchSpiffs(
  arg?: UseSearchQueryHookArg<SearchSpiffsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchSpiffsRes, SearchSpiffsResult> {
  return usePaginatedSearch(
    "searchSpiffs",
    "spiffs",
    SearchSpiffsReq,
    arg,
    options
  )
}

export function useSearchSalesV2(
  arg?: UseSearchQueryHookArg<SearchSalesV2Req>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchSalesV2Res, SearchSalesV2Result> {
  return usePaginatedSearch(
    "searchSalesV2",
    "sales",
    SearchSalesV2Req,
    arg,
    options
  )
}

export function useSearchReceivablesAging(
  arg?: UseSearchQueryHookArg<SearchReceivablesAgingReq>,
  options?: SearchOptions
): UseUnpaginatedSearchQueryHookResult<
  SearchReceivablesAgingRes,
  SearchReceivablesAgingResult
> {
  return useUnpaginatedSearch(
    "searchReceivablesAging",
    "receivables-aging",
    SearchReceivablesAgingReq,
    arg,
    options
  )
}

export function useSearchReallocationReceivables(
  arg?: UseSearchQueryHookArg<SearchReallocationReceivablesReq>,
  options?: SearchOptions
): UseUnpaginatedSearchQueryHookResult<
  SearchReallocationReceivablesRes,
  SearchReallocationReceivablesRes_Result
> {
  return useUnpaginatedSearch(
    "searchReallocationReceivables",
    "reallocation-receivables",
    SearchReallocationReceivablesReq,
    arg,
    options
  )
}

export function useSearchTransfers(
  arg?: UseSearchQueryHookArg<SearchTransfersReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchTransfersRes,
  SearchTransfersResult
> {
  return usePaginatedSearch(
    "searchTransfers",
    "transfers",
    SearchTransfersReq,
    arg,
    options
  )
}

export function useSearchVendors(
  arg?: UseSearchQueryHookArg<SearchVendorsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchVendorsRes, SearchVendorsResult> {
  return usePaginatedSearch(
    "searchVendors",
    "vendors",
    SearchVendorsReq,
    arg,
    options
  )
}

export function useSearchSavedReportsQuery(
  arg: UseSearchQueryHookArg<SearchSavedReportsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchSavedReportsRes,
  SearchSavedReportsRes_Result
> {
  return usePaginatedSearch(
    "searchSavedReports",
    "saved-reports",
    SearchSavedReportsReq,
    arg,
    options
  )
}

export function useSearchTintColors(): UseUnpaginatedSearchQueryHookResult<
  SearchTintColorsRes,
  SearchTintColorsResult
> {
  return useUnpaginatedSearch(
    "searchTintColors",
    "tint-colors",
    SearchTintColorsReq
  )
}

export function useSearchCashTransactions(
  arg?: UseSearchQueryHookArg<SearchCashTransactionsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchCashTransactionsRes,
  SearchCashTransactionResult
> {
  return usePaginatedSearch(
    "searchCashTransactions",
    SearchQueryKeys.CashTransactions,
    SearchCashTransactionsReq,
    arg,
    options
  )
}

export function useInvalidateSearchCashTransactions() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["search", SearchQueryKeys.CashTransactions],
    })
  }
}

export function useSearchCredits(
  arg?: UseSearchQueryHookArg<SearchCreditsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchCreditsRes, SearchCreditsResult> {
  return usePaginatedSearch(
    "searchCredits",
    "credits",
    SearchCreditsReq,
    arg,
    options
  )
}

export function useSearchFinancialTransactions(
  arg?: UseSearchQueryHookArg<SearchFinancialTransactionsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchFinancialTransactionsRes,
  SearchFinancialTransactionsResult
> {
  return usePaginatedSearch(
    "searchFinancialTransactions",
    SearchQueryKeys.FinancialTransactions,
    SearchFinancialTransactionsReq,
    arg,
    options
  )
}

export function useInvalidateSearchFinancialTransactions() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["search", SearchQueryKeys.FinancialTransactions],
    })
  }
}

export function useSearchExternalTransactions(
  arg?: UseSearchQueryHookArg<SearchExternalTransactionsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchExternalTransactionsRes,
  SearchExternalTransactionsResult
> {
  return usePaginatedSearch(
    "searchExternalTransactions",
    SearchQueryKeys.ExternalTransactions,
    SearchExternalTransactionsReq,
    arg,
    options
  )
}

export function useInvalidateSearchExternalTransactions() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["search", SearchQueryKeys.ExternalTransactions],
    })
  }
}

export function useSearchOrderShipmentsForReconciliation(
  arg?: UseSearchQueryHookArg<SearchOrderShipmentsForReconciliationReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchOrderShipmentsForReconciliationRes,
  SearchOrderShipmentsForReconciliationResult
> {
  return usePaginatedSearch(
    "searchOrderShipmentsForReconciliation",
    "order-shipments-for-reconciliation",
    SearchOrderShipmentsForReconciliationReq,
    arg,
    options
  )
}

export function useSearchInventoryChanges(
  arg?: UseSearchQueryHookArg<SearchInventoryChangesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchInventoryChangesRes,
  SearchInventoryChangesResult
> {
  return usePaginatedSearch(
    "searchInventoryChanges",
    "inventory-changes",
    SearchInventoryChangesReq,
    arg,
    options
  )
}

export function useSearchJobs(
  arg?: UseSearchQueryHookArg<SearchJobsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchJobsRes, SearchJobsResult> {
  return usePaginatedSearch("searchJobs", "jobs", SearchJobsReq, arg, options)
}

export function useSearchTags(
  arg?: UseSearchQueryHookArg<SearchTagsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<SearchTagsRes, SearchTagsRes_Result> {
  return usePaginatedSearch("searchTags", "tags", SearchTagsReq, arg, options)
}

export function useSearchStagedProductsToOrder(
  arg?: UseSearchQueryHookArg<SearchStagedProductsToOrderReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchStagedProductsToOrderRes,
  SearchStagedProductsToOrderRes_Result
> {
  return usePaginatedSearch(
    "searchStagedProductsToOrder",
    "stagedProductsToOrder",
    SearchStagedProductsToOrderReq,
    arg,
    options
  )
}

export function useSearchCatalogSKUs(
  arg?: UseSearchQueryHookArg<SearchCatalogSKUsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchCatalogSKUsRes,
  SearchCatalogSKUsResult
> {
  return usePaginatedSearch(
    "searchCatalogSKUs",
    "catalogSKUs",
    SearchCatalogSKUsReq,
    arg,
    options
  )
}

export function useSearchCatalogProducts(
  arg?: UseSearchQueryHookArg<SearchCatalogProductsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchCatalogProductsRes,
  SearchCatalogProductsResult
> {
  return usePaginatedSearch(
    "searchCatalogProducts",
    "catalogProducts",
    SearchCatalogProductsReq,
    arg,
    options
  )
}

export function useSearchStatements(
  arg?: UseSearchQueryHookArg<SearchStatementsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchStatementsRes,
  SearchStatementsRes_Result
> {
  return usePaginatedSearch(
    "searchStatements",
    "statements",
    SearchStatementsReq,
    arg,
    options
  )
}

export function useSearchCustomerStatements(
  arg?: UseSearchQueryHookArg<SearchCustomerStatementsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchCustomerStatementsRes,
  SearchCustomerStatementsRes_Result
> {
  return usePaginatedSearch(
    "searchCustomerStatements",
    "customerStatements",
    SearchCustomerStatementsReq,
    arg,
    options
  )
}

export function useSearchStatementRuns(
  arg?: UseSearchQueryHookArg<SearchStatementRunsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchStatementRunsRes,
  SearchStatementRunsRes_Result
> {
  return usePaginatedSearch(
    "searchStatementRuns",
    "statementRuns",
    SearchStatementRunsReq,
    arg,
    options
  )
}

export function useSearchFinanceCharges(
  arg?: UseSearchQueryHookArg<SearchFinanceChargesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchFinanceChargesRes,
  SearchFinanceChargesResult
> {
  return usePaginatedSearch(
    "searchFinanceCharges",
    "financeCharges",
    SearchFinanceChargesReq,
    arg,
    options
  )
}

export function useSearchAccounts(
  arg?: UseSearchQueryHookArg<SearchAccountsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchAccountsRes,
  SearchAccountsRes_Result
> {
  return usePaginatedSearch(
    "searchAccounts",
    "accounts",
    SearchAccountsReq,
    arg,
    options
  )
}

export function useBulkExportAccounts() {
  return useBulkMutation<BulkExportAccountsReq, BulkExportAccountsRes>(
    "bulkExportAccounts"
  )
}

export function useInvalidateSearchAccounts() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["search", SearchQueryKeys.Accounts],
    })
  }
}

export function useInvalidateSearchMappings() {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: ["search", SearchQueryKeys.Mappings],
    })
  }
}

export function useSearchMappings(
  arg?: UseSearchQueryHookArg<SearchMappingsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchMappingsRes,
  SearchMappingsRes_Result
> {
  return usePaginatedSearch(
    "searchMappings",
    SearchQueryKeys.Mappings,
    SearchMappingsReq,
    arg,
    options
  )
}

export function useBulkExportMappings() {
  return useBulkMutation<BulkExportMappingsReq, BulkExportMappingsRes>(
    "bulkExportMappings"
  )
}

export function useSearchDeliveries(
  arg?: UseSearchQueryHookArg<SearchDeliveriesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchDeliveriesRes,
  SearchDeliveriesResult
> {
  return usePaginatedSearch(
    "searchDeliveries",
    "deliveries",
    SearchDeliveriesReq,
    arg,
    options
  )
}

export function useUnpaginatedSearchDeliveries(
  arg?: UseSearchQueryHookArg<Omit<SearchDeliveriesReq, "offset" | "cursor">>,
  options?: SearchOptions
): UseUnpaginatedSearchQueryHookResult<
  SearchDeliveriesRes,
  SearchDeliveriesResult
> {
  return useUnpaginatedSearch(
    "searchDeliveries",
    "deliveries",
    SearchDeliveriesReq,
    arg,
    options
  )
}

export function useSearchDeliveryStops(
  arg?: UseSearchQueryHookArg<SearchDeliveryStopsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchDeliveryStopsRes,
  SearchDeliveryStopsResult
> {
  return usePaginatedSearch(
    "searchDeliveryStops",
    "delivery-stops",
    SearchDeliveryStopsReq,
    arg,
    options
  )
}

export function useSearchNotifDeliveries(
  arg?: UseSearchQueryHookArg<SearchNotifDeliveriesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchNotifDeliveriesRes,
  SearchNotifDeliveriesRes_Result
> {
  return usePaginatedSearch(
    "searchNotifDeliveries",
    "notif-deliveries",
    SearchNotifDeliveriesReq,
    arg,
    options
  )
}

export function useSearchJournalEntries(
  arg?: UseSearchQueryHookArg<SearchJournalEntriesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchJournalEntriesRes,
  SearchJournalEntriesRes_Result
> {
  return usePaginatedSearch(
    "searchJournalEntries",
    "journalEntries",
    SearchJournalEntriesReq,
    arg,
    options
  )
}

export function useSearchManualJournalEntries(
  arg?: UseSearchQueryHookArg<SearchManualJournalEntriesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchManualJournalEntriesRes,
  SearchManualJournalEntriesRes_Result
> {
  return usePaginatedSearch(
    "searchManualJournalEntries",
    "manualJournalEntries",
    SearchManualJournalEntriesReq,
    arg,
    options
  )
}

export function useSearchPriceChanges(
  arg?: UseSearchQueryHookArg<SearchPriceChangesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchPriceChangesRes,
  SearchPriceChangesResult
> {
  return usePaginatedSearch(
    "searchPriceChanges",
    "price-changes",
    SearchPriceChangesReq,
    arg,
    options
  )
}

export function useSearchReceivablesHistory(
  arg?: UseSearchQueryHookArg<SearchReceivablesHistoryReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchReceivablesHistoryRes,
  SearchReceivablesHistoryResult
> {
  return usePaginatedSearch(
    "searchReceivablesHistory",
    "receivablesHistory",
    SearchReceivablesHistoryReq,
    arg,
    options
  )
}

export function useLazyPrintReceivablesHistory() {
  const { client } = useSearchClient()
  return useMutation<
    PrintReceivablesHistoryRes,
    ApiError,
    PrintReceivablesHistoryReq
  >({
    mutationFn: async (req: PrintReceivablesHistoryReq) => {
      const { response } = await client.printReceivablesHistory(req)
      return response
    },
  })
}

export function useLazyPrintReceivablesAging() {
  const { client } = useSearchClient()
  return useMutation<
    PrintReceivablesAgingRes,
    ApiError,
    PrintReceivablesAgingReq
  >({
    mutationFn: async (req: PrintReceivablesAgingReq) => {
      const { response } = await client.printReceivablesAging(req)
      return response
    },
  })
}

const SEARCHALYTICS_STALE_TIME = Infinity
function useSearchalytics<Req extends object, Res extends object>(
  key: keyof SearchalyticsServiceClient,
  arg: SerializableReq<Req>,
  skip?: boolean
): UseQueryResult<Res, Error> {
  const { client, isReady } = useSearchalyticsClient()

  const fn = (
    client[key] as (input: Req, options?: RpcOptions) => UnaryCall<Req, Res>
  ).bind(client)

  const res = useQuery({
    queryKey: ["searchalytics", key, arg],
    queryFn: async ({ signal }) => {
      const { response } = await fn(restoreSerializableReq(arg) as Req, {
        abort: signal,
      })
      return response
    },
    placeholderData: keepPreviousData,
    enabled: !skip && isReady,
    staleTime: SEARCHALYTICS_STALE_TIME,
    refetchOnWindowFocus: false,
  })

  return res
}

function useLazySearchalytics<Req extends object, Res extends object>(
  key: keyof SearchalyticsServiceClient,
  arg: SerializableReq<Req>
): UseQueryResult<Res, Error> {
  return useSearchalytics<Req, Res>(key, arg, true)
}

interface SearchalyticsReportRes {
  report: Report | undefined
}

interface SearchalyticsReportFileRes {
  bytes: Uint8Array
}

function useLazySearchalyticsReport<
  Req extends object,
  Res extends SearchalyticsReportRes,
>(
  key: keyof SearchalyticsServiceClient,
  arg: SerializableReq<Req>
): useLazyReportDataRes {
  const res = useSearchalytics<Req, Res>(key, arg, true)
  return {
    report: res.data && parseReport(res.data.report),
    triggerReport: () => res.refetch(),
    isFetching: res.isFetching,
    isError: res.isError,
    error: res.error,
  }
}

function useLazySearchalyticsFile<
  Req extends object,
  Res extends SearchalyticsReportFileRes,
>(
  key: keyof SearchalyticsServiceClient,
  arg: SerializableReq<Req>
): useLazyReportFileRes {
  const fileRes = useSearchalytics<Req, Res>(key, arg, true)
  return {
    getBytes: async () => {
      const res = (await fileRes.refetch()).data
      if (!res) {
        throw new Error("No data")
      }
      return res.bytes
    },
    isFetching: fileRes.isFetching,
  }
}

export function useSearchalyticsGetProfitAndLoss(
  arg: SerializableReq<GetProfitAndLossReq>,
  skip?: boolean
): UseQueryResult<GetProfitAndLossRes, Error> {
  return useSearchalytics("getProfitAndLoss", arg, skip)
}

export function useLazySearchalyticsGetProfitAndLossPDF(
  arg: SerializableReq<GetProfitAndLossPDFReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getProfitAndLossPDF", arg)
}

export function useLazySearchalyticsGetPurchaseJournal(
  arg: SerializableReq<GetPurchaseJournalReq>
): useLazyReportDataRes {
  return useLazySearchalyticsReport("getPurchaseJournal", arg)
}

export function useLazySearchalyticsGetPurchaseJournalPDF(
  arg: SerializableReq<GetPurchaseJournalPDFReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getPurchaseJournalPDF", arg)
}

export function useLazySearchalyticsGetPurchaseJournalCSV(
  arg: SerializableReq<GetPurchaseJournalCSVReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getPurchaseJournalCSV", arg)
}

export function useLazySearchalyticsGetPayoutsByPayoutDate(
  arg: SerializableReq<GetPayoutsByPayoutDateReq>
): useLazyReportDataRes {
  return useLazySearchalyticsReport("getPayoutsByPayoutDate", arg)
}

export function useLazySearchalyticsGetPayoutsByPayoutDatePDF(
  arg: SerializableReq<GetPayoutsByPayoutDatePDFReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getPayoutsByPayoutDatePDF", arg)
}

export function useLazySearchalyticsGetPayoutsByPayoutDateCSV(
  arg: SerializableReq<GetPayoutsByPayoutDateCSVReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getPayoutsByPayoutDateCSV", arg)
}

export function useLazySearchalyticsGetPayoutsByTransactionDate(
  arg: SerializableReq<GetPayoutsByTransactionDateReq>
): useLazyReportDataRes {
  return useLazySearchalyticsReport("getPayoutsByTransactionDate", arg)
}

export function useLazySearchalyticsGetPayoutsByTransactionDatePDF(
  arg: SerializableReq<GetPayoutsByTransactionDatePDFReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getPayoutsByTransactionDatePDF", arg)
}

function useLazySerializableReq<Req extends object, Res extends object>(
  key: keyof SearchalyticsServiceClient,
  arg: Req,
  serialize: (arg: Req) => string
): UseQueryResult<Res, Error> {
  const { client } = useSearchalyticsClient()

  const fn = (
    client[key] as (input: Req, options?: RpcOptions) => UnaryCall<Req, Res>
  ).bind(client)

  const res = useQuery({
    queryKey: ["searchalytics", key, serialize(arg)],
    queryFn: async ({ signal }) => {
      const { response } = await fn(arg, { abort: signal })
      return response
    },
    placeholderData: keepPreviousData,
    enabled: false,
    staleTime: SEARCHALYTICS_STALE_TIME,
    refetchOnWindowFocus: false,
  })
  return res
}

export function useLazyGetIncomeStatement(
  arg: GetIncomeStatementReq
): UseQueryResult<GetIncomeStatementRes, Error> {
  return useLazySerializableReq("getIncomeStatement", arg, (arg) =>
    stringify(arg)
  )
}

export function useLazyGetBalanceSheet(
  arg: GetBalanceSheetReq
): UseQueryResult<GetBalanceSheetRes, Error> {
  return useLazySerializableReq("getBalanceSheet", arg, (arg) => stringify(arg))
}

export function useLazySearchalyticsGetJournalEntries(
  arg: SerializableReq<GetJournalEntriesReq>
): UseQueryResult<GetJournalEntriesRes, Error> {
  return useLazySearchalytics("getJournalEntries", arg)
}

export function useLazySearchalyticsGetJournalEntriesPDF(
  arg: SerializableReq<GetJournalEntriesPDFReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getJournalEntriesPDF", arg)
}

export function useLazySearchalyticsGetJournalEntriesIIF(
  arg: SerializableReq<GetJournalEntriesIIFReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getJournalEntriesIIF", arg)
}

export function useLazySearchalyticsGetPayoutsByTransactionDateCSV(
  arg: SerializableReq<GetPayoutsByTransactionDateCSVReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getPayoutsByTransactionDateCSV", arg)
}

// ACCOUNTING
export function useLazySearchalyticsGetGeneralLedger(
  arg: SerializableReq<GetGeneralLedgerReq>
): useLazyReportDataRes {
  return useLazySearchalyticsReport("getGeneralLedger", arg)
}

export function useLazySearchalyticsGetGeneralLedgerPDF(
  arg: SerializableReq<GetGeneralLedgerPDFReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getGeneralLedgerPDF", arg)
}

export function useLazySearchalyticsGetGeneralLedgerCSV(
  arg: SerializableReq<GetGeneralLedgerCSVReq>
): useLazyReportFileRes {
  return useLazySearchalyticsFile("getGeneralLedgerCSV", arg)
}
// END ACCOUNTING

// OTHER ENDPOINTS

export function useSearchGiftCards(
  arg?: UseSearchQueryHookArg<SearchGiftCardsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchGiftCardsRes,
  SearchGiftCardsResult
> {
  return usePaginatedSearch(
    "searchGiftCards",
    "giftcards",
    SearchGiftCardsReq,
    arg,
    options
  )
}

export function useSearchRoutines(
  arg?: UseSearchQueryHookArg<SearchRoutinesReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchRoutinesRes,
  SearchRoutinesRes_Result
> {
  return usePaginatedSearch(
    "searchRoutines",
    "routines",
    SearchRoutinesReq,
    arg,
    options
  )
}

export function useSearchConversations(
  arg?: UseSearchQueryHookArg<SearchConversationsReq>,
  options?: SearchOptions
): UsePaginatedSearchQueryHookResult<
  SearchConversationsRes,
  SearchConversationsRes_Result
> {
  return usePaginatedSearch(
    "searchConversations",
    "conversations",
    SearchConversationsReq,
    arg,
    options
  )
}

export function useListIntegrationVendorsWithCatalogs(skip?: boolean) {
  const { client, isReady } = useSearchClient()
  return useQuery<ListIntegrationVendorsWithCatalogsRes, Error>({
    queryKey: ["search", "listIntegrationVendorsWithCatalogs"],
    queryFn: async () => {
      const { response } = await client.listIntegrationVendorsWithCatalogs({})
      return response
    },
    enabled: !skip && isReady,
  })
}

export function useSearchListPromotionalSaleCodes(skip?: boolean) {
  const { client, isReady } = useSearchClient()
  return useQuery<SearchListPromotionalSaleCodesRes, Error>({
    queryKey: ["search", "listPromotionalSaleCodes"],
    queryFn: async () => {
      const { response } = await client.searchListPromotionalSaleCodes({})
      return response
    },
    enabled: !skip && isReady,
  })
}
